export default "__VITE_ASSET__DSKNgAQX__"